import { ArticleCardSkeleton } from '@xing-com/crate-career-hub-article-card';
import { GridContainer, GridItem } from '@xing-com/grid';
import { SkeletonBody } from '@xing-com/skeleton';

import { MOCKED_ARTICLE_NUMBER } from '../constants';

import { Styled } from './topic-page-skeleton.styles';

export const TopicPageSkeleton: React.FC = () => (
  <GridContainer variant="FullSize">
    <GridItem span={12}>
      <Styled.SkeletonHeadline size="large" />
      <Styled.SkeletonBodyCopy />
      <SkeletonBody />
    </GridItem>
    <Styled.GridItem span={8} spanMedium={6}>
      <Styled.SkeletonCarouselHeadline amountRows={1} />
    </Styled.GridItem>
    <GridItem span={12}>
      <SkeletonBody amountRows={1} />
      <Styled.Carousel>
        {Array.from(Array(MOCKED_ARTICLE_NUMBER).keys()).map((id) => (
          <ArticleCardSkeleton key={id} />
        ))}
      </Styled.Carousel>
      <Styled.Divider />
    </GridItem>
  </GridContainer>
);
